import * as React from "react"

import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import { GlobalState } from "../../../../../../store"
import { itemSelector } from "../../../../../resources/adapters"
import { fetchItem } from "../../../../../resources/thunks"

import Button from "../Button"
import UnavailableLink from "../UnavailableLink"
import { IGlobalActionsController } from "../../../../../../global"

declare let globalActionsController: IGlobalActionsController

interface Props {
    attributes: Record<string, string>
    label: string
    itemId: number
}

export const DeleteItem = ({
    attributes,
    label,
    itemId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const item = itemSelector.selectById(resources, itemId)

    React.useEffect(() => {
        if (!item) {
            dispatch(fetchItem(itemId))
        }
    }, [])

    if (!item) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (item.doesExist) {
        // javascript:globalActionsController.deleteItem(itemId,itemTitle);
        const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
            event.stopPropagation()
            globalActionsController.deleteItem(item.id, item.title)
        }

        return (
            <Button attributes={attributes} label={label} onClick={onClick} />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default DeleteItem
